export default __webpack_public_path__ + "static/media/amazon2-placeholder.3aa729de.png";